(function () {
  var root = document.querySelector('[data-mgh]');
  if (!root) return;

  // Offset sticky elements below the theme's sticky header, if it has one.
  function setStickyTop() {
    var header = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
    var top = 0;
    if (header) {
      var style = getComputedStyle(header);
      var sticky = style.position === 'sticky' || style.position === 'fixed' ||
        header.classList.contains('shopify-section-header-sticky');
      var rect = header.getBoundingClientRect();
      if (sticky && rect.bottom > 0) top = Math.round(rect.bottom);
    }
    document.documentElement.style.setProperty('--mgh-sticky-top', top + 'px');
  }
  setStickyTop();
  window.addEventListener('resize', setStickyTop, { passive: true });
  window.addEventListener('scroll', function () { window.requestAnimationFrame(setStickyTop); }, { passive: true });

  // Reviews link: show it only when a reviews widget is on the page.
  var reviews = document.querySelector('.jdgm-widget, #looxReviews, .loox-reviews-default, #shopify-product-reviews');
  var reviewsLink = root.querySelector('[data-mgh-reviews-link]');
  if (reviews && reviewsLink) {
    reviews.style.scrollMarginTop = 'calc(var(--mgh-sticky-top) + 6rem)';
    if (!reviews.id) reviews.id = 'mgh-reviews-widget';
    reviewsLink.href = '#' + reviews.id;
    reviewsLink.hidden = false;
  }

  // Highlight the nav link for the section in view.
  var links = Array.prototype.slice.call(root.querySelectorAll('.mgh-nav__link'));
  var targets = links.map(function (a) {
    var id = a.getAttribute('href').slice(1);
    return document.getElementById(id);
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = targets.indexOf(e.target);
        links.forEach(function (a, j) { a.classList.toggle('is-active', j === i); });
        if (links[i] && links[i].scrollIntoView && links[i].parentNode.scrollWidth > links[i].parentNode.clientWidth) {
          links[i].parentNode.scrollTo({ left: links[i].offsetLeft - 24, behavior: 'smooth' });
        }
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    targets.forEach(function (t) { if (t) io.observe(t); });
  }

  // Load videos only when clicked.
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mgh-video]');
    if (!btn) return;
    var iframe = document.createElement('iframe');
    iframe.src = btn.getAttribute('data-mgh-video');
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.title = btn.getAttribute('aria-label') || 'Video';
    btn.replaceWith((function () {
      var wrap = document.createElement('div');
      wrap.className = 'mgh-video';
      wrap.appendChild(iframe);
      return wrap;
    })());
  });
})();